$(document).ready(function () {
  $('.js-toggler').on('click', function () {
    $('.js-toggle[data-toggle=' + $(this).attr('data-toggle') + ']').slideToggle()
  })
  $('.js--minus').on('click', function () {
    var $input = $(this).parent().find('input')
    var count = parseInt($input.val()) || 0
    var newCount = count - 1
    $input.val(newCount > 0 ? newCount : 1)
  })
  $('.js--add').on('click', function () {
    var $input = $(this).parent().find('input')
    var count = parseInt($input.val()) || 0
    $input.val(count + 1)
  })
})
